import { SmartContractRuleContractorCompetencyID } from '../../../../smartContracts/smartContractsTypes';

export type CheckInTasksFormData = {
  contractorCompetencyId: SmartContractRuleContractorCompetencyID;
};

export const enum CheckInTasksFormFields {
  CONTRACTOR_COMPETENCY_ID = 'contractorCompetencyId'
}
